import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Alert from '../../molecules/Alert'
import clsx from 'clsx'

const OfficeHourCard = ({ title, status, items, key }) => {
  return (
    <div className="bg-white p-8 md:w-1/2 rounded-xl">
      <p className="flex flex-col md:flex-row gap-2 justify-between">
        <span className="font-bold">{title}</span>
        <span>{status}</span>
      </p>
      <hr className="my-4" />
      {items.map((item, index) => (
        <Fragment key={`${key}-${index}`}>
          <p className={clsx('mb-4', index === items.length - 1 && 'mt-6')}>
            <span className="font-bold block mb-2">{item.title}</span>
            <span>{item.value}</span>
          </p>
          {item.valueWarning ? (
            <Alert>
              El horario de atención es menor a 8 horas, sugiere a la entidad configurar un horario sugerido más amplio.
            </Alert>
          ) : null}
        </Fragment>
      ))}
    </div>
  )
}

export default OfficeHourCard

OfficeHourCard.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string,
  items: PropTypes.array.isRequired,
  key: PropTypes.string.isRequired
}
